<template>
  <div class="item-tax-controls">
    <div v-if="item.usar_imposto_manual" class="item-tax-manual-display">
      <label>Imposto</label><span>Imposto manual</span>
    </div>
    <div class="item-tax-actions">
      <button v-if="item.usar_imposto_manual" type="button" class="item-tax-action item-tax-edit"
        aria-label="Editar imposto manual" @click="$bvModal.show(modalId)">
        <b-icon-pencil-square scale="1.3" />
      </button>
      <button type="button" class="item-tax-action" :aria-label="item.usar_imposto_manual ? 'Usar imposto da REF' : 'Usar imposto manual'"
        @click="$set(item, 'usar_imposto_manual', !item.usar_imposto_manual)">
        <b-icon-arrow-left-right scale="1.3" />
      </button>
    </div>
    <b-modal :id="modalId" size="xl" title="Imposto manual do item" @show="prepareDraft">
      <ManualTax item-mode :imposto-manual="draft" :flags="manualFlags"
        @update:impostoManual="draft = $event" @updateFlags="manualFlags = $event" />
      <template #modal-footer>
        <b-button variant="secondary" size="sm" @click="$bvModal.hide(modalId)">Cancelar</b-button>
        <b-button variant="primary" size="sm" @click="saveDraft">Salvar imposto do item</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ManualTax from "./ManualTax.vue";
import { cloneTaxData, completeManualTaxDefaults, createManualTax } from "../../utils/itemTax";

export default {
  components: { ManualTax },
  props: { item: { type: Object, required: true }, modalId: { type: String, required: true } },
  data() {
    return { draft: createManualTax(), manualFlags: { enableCreditoPresumido: false, enableIssqn: false } };
  },
  methods: {
    prepareDraft() {
      this.draft = completeManualTaxDefaults(this.item.imposto_manual);
      this.manualFlags = {
        enableCreditoPresumido: Boolean(this.draft.icms?.informar_credito_presumido),
        enableIssqn: Boolean(this.draft.issqn?.informar_issqn),
      };
    },
    saveDraft() {
      this.$set(this.draft.icms, "informar_credito_presumido", this.manualFlags.enableCreditoPresumido);
      this.$set(this.draft.issqn, "informar_issqn", this.manualFlags.enableIssqn);
      this.$set(this.item, "imposto_manual", cloneTaxData(this.draft));
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>

<style scoped>
.item-tax-controls { position: absolute; inset: 0; height: 30px; z-index: 11; pointer-events: none; }
.item-tax-manual-display { position: absolute; inset: 0; height: 30px; display: flex; align-items: center;
  padding: 0 67px 0 11px; border: 1px solid #ced4da; border-radius: 4px; background: white;
  color: #495057; font-size: 12px; white-space: nowrap; pointer-events: auto; }
.item-tax-manual-display label { position: absolute; top: -6px; left: 4px; background: white;
  padding: 0 3px; font-size: 9px; font-weight: 600; line-height: 12px; }
.item-tax-manual-display span { overflow: hidden; text-overflow: ellipsis; }
.item-tax-actions { position: absolute; right: 0; top: 0; z-index: 2; height: 100%; display: flex; pointer-events: auto; }
.item-tax-action { display: inline-flex; align-items: center; justify-content: center; flex: 0 0 30px;
  width: 30px; height: 100%; padding: 0; border: 1px solid #dedede; border-left: none;
  border-radius: 0 3px 3px 0; background: #fff; color: #00395d; cursor: pointer; }
.item-tax-edit { border-color: #00395d; border-radius: 3px 0 0 3px; background: #00395d; color: #fff; }
.item-tax-edit + .item-tax-action { border-left: 0; border-radius: 0 3px 3px 0; }
</style>
